enum VehicleLevel {
  Unknown = 0,
  Manufacturer = 1,
  Range = 2,
  Model = 3,
  Derivative = 4,
  Trim = 5
}

export default VehicleLevel;
